import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { clearProfile } from "@/components/site/candidate";
import { candidateLogout } from "@/lib/candidate-api";

export const Route = createFileRoute("/logout")({
  head: () => {
    const t = "You're logged out | CLOSDD";
    const d = "You've signed out of your CLOSDD candidate account. Log back in any time to keep applying.";
    return {
      meta: [
        { title: t },
        { name: "description", content: d },
        { property: "og:title", content: t },
        { property: "og:description", content: d },
        { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "robots", content: "noindex" },
      ],
    };
  },
  component: LogoutPage,
});

function LogoutPage() {
  const navigate = useNavigate();

  useEffect(() => {
    clearProfile();
    void candidateLogout();
  }, []);

  return (
    <div className="grid min-h-screen place-items-center bg-cream px-5 py-16">
      <div className="w-full max-w-[540px] rounded-[28px] border border-ink/10 bg-white/80 p-9 text-center">
        <p className="text-[12px] font-bold uppercase tracking-[0.22em] text-purple-strong">CLOSDD</p>
        <h1 className="mt-4 font-serif text-[28px] leading-[1.05] tracking-[-0.02em] text-ink">
          You're logged out.
        </h1>
        <p className="mx-auto mt-4 max-w-[420px] text-[16px] leading-[1.65] text-ink/70">
          Your session on this device has been cleared. Log back in whenever you want to pick up your
          applications.
        </p>
        <div className="mt-8 grid gap-3">
          <button
            type="button"
            onClick={() => navigate({ to: "/login" })}
            className="rounded-full bg-purple-strong px-8 py-4 text-[13px] font-bold uppercase tracking-[0.16em] text-white transition hover:-translate-y-0.5"
          >
            Log back in
          </button>
          <Link
            to="/find-jobs"
            className="rounded-full border border-purple-strong/30 px-8 py-4 text-[13px] font-bold uppercase tracking-[0.16em] text-purple-strong transition hover:bg-purple-soft/60"
          >
            Browse sales roles
          </Link>
        </div>
      </div>
    </div>
  );
}
